
export enum YesNoUnsure {
    YES = 'yes',
    NO = 'no',
    UNSURE = 'unsure'
};

export const YesNoUnsureOptions = [
    {label: 'Yes', id: YesNoUnsure.YES},
    {label: 'No', id: YesNoUnsure.NO},
    {label: "Don't Know", id: YesNoUnsure.UNSURE}
];

export const NoneToExcllentRange = [
    { label: 'None', id: 'none'},
    { label: 'Little', id: 'little'},
    { label: 'Average', id: 'average'},
    { label: 'Above Average', id: 'above average'},
    { label: 'Excellent', id: 'excellent'},
];

export const YesNoOptions = [
    {label: 'Yes', id: YesNoUnsure.YES},
    {label: 'No', id: YesNoUnsure.NO},
];

export const LivingSituation = [
    { label: 'Own', id: 'own' },
    { label: 'Rent', id: 'rent' },
    { label: 'Live with Family', id: 'family' }
];

export const EmploymentStatus = [
    {label: 'Full-time', id: 'fulltime'},
    {label: 'Part-time', id: 'parttime'},
    {label: 'Seasonal', id: 'seasonal'},
    {label: 'Self-Employed', id: 'self'},
    {label: 'Unemployed', id: 'unemployed'},
];

export const LoanTypeOptions = [
    { label: 'Home Mortgage', id: 'home' },
    { label: 'Mortgage Refinance', id: 'refinance' },
    { label: 'Car', id: 'car' },
    { label: 'Personal', id: 'personal' },
    { label: 'Business', id: 'business' }
];

export const reasonForDefaultOptions = [
    { label: 'Foreclosure', id: 'foreclosure' },
    { label: 'Repossession', id: 'repossession' },
    { label: 'Bankruptcy', id: 'bankruptcy' },
    { label: 'Tax Issues', id: 'tax' },
];

export const lifeChangesOptions = [
    { label: 'Marriage', id: 'marriage' },
    { label: 'Health / Medical', id: 'health' },
    { label: 'Divorce', id: 'divorce' },
    { label: 'Birth of Child', id: 'birth' },
    { label: 'Death of Partner / Spouse', id: 'death' }
];

export const hardshipsOptions = [
    { label: 'Divorce', id: 'divorce' },
    { label: 'Medical', id: 'medical' },
    { label: 'Job Loss', id: 'jobLoss' },
    { label: 'Tax', id: 'tax' },
    { label: 'Bankruptcy', id: 'bankruptcy' }
];

export const alimonyOptions = [
    { label: 'Paying Alimony / Child Support', id: 'paying' },
    { label: 'Receiving Alimony / Child Support', id: 'receiving' }
];

export const lowPercentRangeOptions = [
    { label: '0%', id: '0' },
    { label: '20%', id: '20' },
    { label: '25%', id: '25' },
    { label: '30%', id: '25' },
    { label: '45% or more', id: '45+' },
];

export const timelineOptions = [
    { label: '3 months', id: '5' },
    { label: '6 months', id: '15' },
    { label: '1 year', id: '25' },
    { label: 'Longer than 1 year', id: 'LONG' }
];